(() => {
  const BADGE_SELECTOR = '[data-cart-count]';

  function updateBadge(count) {
    const badges = document.querySelectorAll(BADGE_SELECTOR);
    badges.forEach(badge => {
      const value = Number(count) || 0;

      if (value <= 0) {
        badge.hidden = true;
        badge.textContent = '0';
      } else {
        badge.hidden = false;
        badge.textContent = value > 99 ? '99+' : value;
      }
    });
  }

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin'
      });
      if (!response.ok) return;

      const cart = await response.json();
      updateBadge(cart.item_count);
    } catch (_) {}
  }

  function watchCartChanges() {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const res = await originalFetch(...args);

      try {
        const url =
          typeof args[0] === 'string'
            ? args[0]
            : args[0]?.url || '';

        if (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        ) {
          fetchCart();
        }
      } catch (_) {}

      return res;
    };
  }

  document.addEventListener('DOMContentLoaded', () => {
    fetchCart();
    watchCartChanges();

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        fetchCart();
      }
    });
  });
})();
